import Marquee from "react-fast-marquee";
import { TRUST_ITEMS } from "@/data/content";

export default function TrustMarquee() {
  return (
    <section className="border-y border-white/10 bg-[#0a0c12]" data-testid="trust-marquee">
      <div className="py-6">
        <Marquee speed={40} gradient gradientColor="#0a0c12" gradientWidth={120} autoFill>
          {TRUST_ITEMS.map((item, i) => (
            <div key={i} className="flex items-center">
              <span className="font-mono text-sm uppercase tracking-[0.25em] text-white/45 px-10">
                {item}
              </span>
              <span className="h-1 w-1 rotate-45 bg-[#e01e37]/70" />
            </div>
          ))}
        </Marquee>
      </div>
    </section>
  );
}
